import axios from "axios";
import Config from "../../../../../config";

const v2_actionGerarExcelRelatorioChatsPrimeiroContato = (querys) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/dashboard/relatorios/excel/chats/primeiro-contato${querys}`,
        responseType: 'blob'
    });
};

export default v2_actionGerarExcelRelatorioChatsPrimeiroContato;
